module.exports = __webpack_public_path__ + "static/media/sticky.654360e9.svg";